<template>
  <div class="scrollable-container">
    <div class="d-flex" v-bind:class="{'header': showBackBtn}">
      <div v-if="showBackBtn" class="back-icon" @click="backButtonClick">
        <ArrowBackIcon/>
      </div>
      <div class="ms-auto x-icon" @click="hideMenu">
        <CloseIconX/>
      </div>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {defineComponent} from "vue";
import CloseIconX from "@/components/Common/Icons/CloseIconX.vue";
import ArrowBackIcon from "@/components/Common/Icons/ArrowBackIcon.vue";

export default defineComponent({
  components: {ArrowBackIcon, CloseIconX},
  props: {
    showBackBtn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hideMenu() {
      this.$emit('onClose');
    },
    backButtonClick() {
      this.$emit('onBack');
    }
  }
})
</script>

<style lang="scss" scoped>
.header {
  border-bottom: 1px solid $color-brown;
  padding-bottom: 20px;
}
.scrollable-container {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 20px 0;
  box-sizing: border-box;
  border-radius: 30px;
}

.x-icon {
  padding-right: 50px;
  cursor: pointer;
}
.back-icon {
  padding-left: 50px;
  cursor: pointer;
}

.content {
  flex: 1;
  overflow-y: auto;
  padding: 0 20px;
  margin-right: 20px;
}

.content::-webkit-scrollbar {
  width: 15px; /* Width of the scrollbar */
  padding: 5px;
}

.content::-webkit-scrollbar-thumb {
  background: #CEA997;
  border-radius: 6px; /* Roundness of the handle */
  box-shadow: inset 0 0px 0 3.5px #FDF5F1; /* Inner shadow to create narrower effect */
}

.content::-webkit-scrollbar-track {
  background: #FDF5F1; /* Color of the scrollbar track */
  border-radius: 6px; /* Roundness of the track */
  margin: 5px;
}

</style>